import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { educationalVideos } from '../../enhancedMock';

export const EducationalVideos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <section data-testid="educational-videos-section" className="fade-in-section py-12 md:py-20 px-4 bg-darkBrown text-white relative z-10">
      <div className="container mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4">Educational Videos</h2>
          <p className="text-sm md:text-xl text-white/80">Learn about mental health conditions and treatments</p>
          <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
          {educationalVideos.map((video) => (
            <Card
              key={video.id}
              className="group bg-white border-none shadow-xl hover:shadow-2xl transition-all overflow-hidden cursor-pointer"
              onClick={() => setSelectedVideo(video)}
            >
              <div className="relative h-36 md:h-48 overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-primaryOrange rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Play className="text-white ml-1" size={24} />
                  </div>
                </div>
                <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-black/70 px-2 py-0.5 md:px-3 md:py-1 rounded-full text-xs font-semibold">
                  {video.duration}
                </div>
              </div>
              <CardHeader className="p-3 md:p-6">
                <div className="inline-block px-2 py-0.5 md:px-3 md:py-1 bg-primaryOrange/10 text-primaryOrange rounded-full text-xs font-semibold mb-1 md:mb-2">
                  {video.category}
                </div>
                <CardTitle className="text-darkBrown group-hover:text-primaryOrange transition-colors text-base md:text-lg">{video.title}</CardTitle>
              </CardHeader>
              <CardContent className="p-3 pt-0 md:p-6 md:pt-0">
                <p className="text-xs md:text-sm text-gray-600">{video.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {selectedVideo && (
          <div
            className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4"
            onClick={() => setSelectedVideo(null)}
          >
            <div
              className="relative w-full max-w-4xl bg-white rounded-2xl overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                data-testid="video-modal-close-btn"
                className="absolute top-3 right-3 z-10 w-8 h-8 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                onClick={() => setSelectedVideo(null)}
              >
                <X className="text-darkBrown" size={20} />
              </button>
              <div className="aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  src={selectedVideo.videoUrl}
                  title={selectedVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-4 md:p-6">
                <h3 className="text-lg md:text-2xl font-bold text-darkBrown mb-2">{selectedVideo.title}</h3>
                <p className="text-sm text-gray-600">{selectedVideo.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
